import "niimbot-web-bluetooth";

const M2H = { label: "Niimbot M2-H", id: 4608, dpi: 300, protocol: "v4", task: "b1", density: 3, label_type: 1, speed: 1, name_prefixes: ["M2"] };

export const niimbotSupported = () => Boolean(window.Niimbot && window.Niimbot.isSupported());

export async function printToNiimbot(dataUrl, { width, height, copies, density, showAll, onProgress }) {
  const model = { ...M2H, density, name_prefixes: showAll ? [] : M2H.name_prefixes };
  const size = { w_px: width, h_px: height, dpi: 300, margin: 8 };
  await window.Niimbot.printImage(dataUrl, { model, size, copies, density, onProgress });
}
